import _ from 'lodash';
import { cardShape } from '@editor/droplets/utils';

export default function cardsTall() {
  return {
    _id: false,
    type: 'droplet.cardsTall',
    cards: _.times(3, cardShape({ type: 'droplet.cardsTall.cardItem' })),
    mediaQueries: [
      {
        selector: '.drzCard-tall-titleSection',
        properties: [
          {
            property: 'background-color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    firstDrop: false,
    activeCard: null,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-tall/droplet.schema.js